import { SET_ADVISOR_EARNINGS, SET_ADVISOR_METRIX, SET_CURRENT_USER, SET_PAYOUT_LIST, SET_RANKING_LIST, SET_TOP_THREE_RANK } from "../actions/types";

const initialState = {
    advisorEarning: 0,
    rankingList: [],
    rankingListCount: 0,
    payoutList: [],
    payoutListCount: 0,
    topThreeAdvisors: [],
    metrixAdvisor: null,
    currentUser: null,
};
export default function (state = initialState, action) {
    const { type, payload, count } = action;
    switch (type) {
        case SET_ADVISOR_EARNINGS:
            return {
                ...state,
                advisorEarning: payload,
            };
        case SET_RANKING_LIST:
            return {
                ...state,
                rankingList: payload,
                rankingListCount: count,
            }
        case SET_TOP_THREE_RANK:
            return {
                ...state,
                topThreeAdvisors: payload
            }
        case SET_PAYOUT_LIST:
            return {
                ...state,
                payoutList: payload,
                payoutListCount: count
            }
        case SET_ADVISOR_METRIX:
            return {
                ...state,
                metrixAdvisor: payload
            }
        case SET_CURRENT_USER:
            return {
                ...state,
                currentUser: payload
            }
        default:
            return state;
    }
}
